import React from "react";
import { ArrowUpIcon } from "@chakra-ui/icons";
import ReportCard from "../ui/ReportCard";
import total from "../../images/status-up.png";

export default function TotalReport({ report }) {
  return <ReportCard src={total} title="Total Report" text={report} />;
}
